export const validateRequired = (value: any): string => {
    if (value === undefined || value === null || value === '') {
      return 'は必須項目です';
    }
    return '';
};

export const validateValue = (value: any): string => {
  const trimmedValue = typeof value === 'string' ? value.trim() : value;

  if (trimmedValue === undefined || trimmedValue === null || trimmedValue === '') {
    return 'は必須項目です';
  }

  return '';
};

export const validateDuplicate = (value: string | number | undefined, id: string, dataRow: any[]): string => {
    const isDuplicate = dataRow.some(row => row.orgItemCode === value && row.id !== id);
    if (isDuplicate) {
      return '入力値はすでに登録されています';
    }
    return '';
};
  
export const validate4to13Length = (value: string | number | undefined): string[] => {
  const errors: string[] = [];
  const stringValue = value !== undefined ? String(value) : '';
  const regex4to13 = /^[0-9]{4,13}$/;

  if (value === '' || value == null || stringValue === '') {
    return errors;
  } 
  
  if (!regex4to13.test(stringValue)) {
    errors.push('は4桁以上13桁以下の数字を入力してください'); 
  }
  
  return errors;
};

export const validate4to14Length = (value: string | number | undefined): string[] => {
  const errors: string[] = [];
  const stringValue = value !== undefined ? String(value) : '';
  const regex4to14 = /^[0-9]{4,14}$/;

  if (value === '' || value === null || value === undefined || stringValue === '') {
    return errors;
  } 
  
  if (!regex4to14.test(stringValue)) {
    errors.push('は4桁以上14桁以下の数字を入力してください'); 
  }
  
  return errors;
};

export const validate6to10Length = (value: string | number | undefined): string[] => {
  const errors: string[] = [];
  
  const stringValue = value !== undefined ? String(value) : '';
  if (value === '' || value === null || value === undefined || stringValue === '') {
    return errors;
  } 

  const regex6to10 = /^[0-9]{6,10}$/;
  if (!regex6to10.test(stringValue)) {
    errors.push('は6桁以上10桁以下の数字を入力してください。');
  }

  return errors;
};

export const validateNumberLength = (value: string | number | undefined, num: number): string[] => {
  const errors: string[] = [];
  const stringValue = value !== undefined ? String(value) : '';
  if (value === '' || value == null || stringValue === '') {
    return errors;
  }
  const regex = new RegExp(`^[0-9]{${num}}$`);
  if (!regex.test(stringValue)) {
    errors.push(`は${num}桁の数字を入力してください。`);
  }
  return errors;
};

/**
 * File size validation constants
 */
const MAX_FILE_SIZE_MB = 30
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024 // 30MB in bytes

export interface FileSizeCheckResult {
  isValid: boolean
  errorMessage?: string
}


export const validateWeight = (value: any): string => {
  if (value === undefined || value === null || value === '') {
    return 'は必須項目です';
  }
  
  if (Number.isNaN(value)) {
    return 'は数値を入力してください';
  }
  
  if (value < 1) {
    return 'は1以上で入力してください';
  }
  
  return '';
};
